import { gql } from 'apollo-boost'

export const SENT_BROADCAST = gql`
  mutation sendBroadCast($data: sendBroadCast) {
    sendBroadCast(data: $data)
  }
`

